import React, { useContext } from "react";
import { NotificationInfo, UserInfo } from "../../../context";
import MerchantLayout from "../../layout/MerchantLayout";
import { Button, Input, QRCode } from "antd";
import axios from "axios";

const MerchantQRCode = () => {
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);

  const downloadQRCode = () => {
    const canvas = document.getElementById("myqrcode")?.querySelector("canvas");
    if (canvas) {
      const url = canvas.toDataURL();
      const a = document.createElement("a");
      a.download = "QRCode.png";
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  const handleChangeUID = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    axios
      .post("user/merchant/update-merchant-uid", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated UID successfully.");
          setTimeout(() => {
            // handleRerunUser();
            window.location.reload();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  return (
    <MerchantLayout>
      <div
        id="myqrcode"
        style={{
          borderBottom: "1px solid #e5e5e5",
          marginBottom: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 20,
        }}
      >
        <QRCode
          value={`${process.env.REACT_APP_API_SITE_URL}${userData.data.id}/${userData.data.merchant_uid}`}
          style={{
            marginBottom: 16,
          }}
        />
        <Button type="primary" onClick={downloadQRCode}>
          Download
        </Button>
      </div>
      <div
        id="myqrcode"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Input
          defaultValue={userData.data.merchant_uid}
          style={{ width: 300, marginBottom: 16 }}
          disabled
        />
        <Button type="primary" onClick={handleChangeUID} style={{ width: 100 }}>
          Change UID
        </Button>
      </div>
      {console.log(
        "QRCODE",
        `${process.env.REACT_APP_API_SITE_URL}${userData.data.id}/${userData.data.merchant_uid}`
      )}
    </MerchantLayout>
  );
};

export default MerchantQRCode;
